import { useCallback, useState } from 'react';
import { useAuth0, RedirectLoginOptions } from '@auth0/auth0-react';

/**
 * Hook that wraps loginWithRedirect to provide loading state during Auth0 redirect.
 * Shows a loading indicator from the moment redirect is initiated until the page navigates away.
 */
export function useAuth0Redirect() {
  const { loginWithRedirect: auth0LoginWithRedirect, ...auth0Rest } = useAuth0();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const loginWithRedirect = useCallback(
    async (options?: RedirectLoginOptions) => {
      setIsRedirecting(true);
      try {
        await auth0LoginWithRedirect(options);
      } catch (error) {
        setIsRedirecting(false);
        throw error;
      }
    },
    [auth0LoginWithRedirect]
  );

  return {
    ...auth0Rest,
    loginWithRedirect,
    isRedirecting,
  };
}
